import apiClient from './apiClient';
import logger from '../../utils/logger';

export interface UserProfileFromAPI {
  uid: string;
  email?: string;
  username?: string;
  display_name?: string;
  photo_url?: string;
  belt_level?: string;
  is_instructor: boolean;
  is_premium: boolean;
  is_admin: boolean;
  created_at?: number;
  metadata?: Record<string, any>;
}

/**
 * Get the current user's profile from the API
 * This includes data from Postgres like isAdmin
 */
export const getCurrentUserProfile = async (): Promise<UserProfileFromAPI> => {
  try {
    logger.info('[User API Service] Fetching current user profile from API');
    const response = await apiClient.get<UserProfileFromAPI>('/api/users/me');
    logger.info('[User API Service] User profile response:', response);
    return response;
  } catch (error) {
    logger.error('[User API Service] Error fetching user profile:', error);
    throw error;
  }
};

/**
 * Get a specific user's profile
 */
export const getUserProfile = async (userId: string): Promise<UserProfileFromAPI> => {
  try {
    const response = await apiClient.get<UserProfileFromAPI>(`/api/users/${userId}`);
    return response;
  } catch (error) {
    logger.error(`[User API Service] Error fetching profile for user ${userId}:`, error);
    throw error;
  }
};

/**
 * Update a user's profile
 */
export const updateUserProfile = async (userId: string, data: any): Promise<UserProfileFromAPI> => {
  try {
    logger.info(`[User API Service] Updating profile for user ${userId}`, data);
    const response = await apiClient.put<UserProfileFromAPI>(`/api/users/${userId}`, data);
    logger.info('[User API Service] Profile update response:', response);
    return response;
  } catch (error) {
    logger.error(`[User API Service] Error updating profile for user ${userId}:`, error);
    throw error;
  }
};

export const userAPIService = {
  getCurrentUserProfile,
  getUserProfile,
  updateUserProfile
};